"use client"

import { useEffect, useState } from "react"
import { trackFactFinderRecommendationAction } from "@/actions/factFinderTrackingActions"

import { ReducedProductData } from "@/lib/storefront/product/product"

/**
 * Component for tracking recommendation clicks
 * This component adds a click event listener to the product element and tracks the click using FactFinder
 */
export default function FFRecommendationClickTrackingClient(props: {
  trackingMarker: string
  productData: ReducedProductData
  mainProductId: string
}) {
  const [tracked, setTracked] = useState(false)

  useEffect(() => {
    function trackingHandler() {
      console.info("Tracking recommendation click")
      // Track in FactFinder using server action
      trackFactFinderRecommendationAction(
        props.productData.id,
        props.mainProductId,
        props.productData.title,
        props.productData.productMasterSKU
      ).catch((error) => console.error("Error calling trackFactFinderRecommendationAction:", error))
      setTracked(true)
    }

    if (!tracked) {
      const element = document.querySelector('[data-tracking-marker="' + props.trackingMarker + '"]')
      if (element) {
        element.addEventListener("click", trackingHandler)
      }
    }

    return () => {
      const element = document.querySelector('[data-tracking-marker="' + props.trackingMarker + '"]')
      if (element) {
        element.removeEventListener("click", trackingHandler)
      }
    }
  }, [props.productData, props.mainProductId, props.trackingMarker, tracked])

  return (
    <>
      <span className={"recoclk hidden"}>{props.trackingMarker}</span>
    </>
  )
}
